// src/composables/useAlgorithmFilter.js
import { ref, computed } from 'vue';

export function useAlgorithmFilter(algorithms, filterDefinitions) {
  const activeFilter = ref('all');

  const visibleAlgorithms = computed(() => {
    if (activeFilter.value === 'all') {
      return algorithms;
    }

    const filter = filterDefinitions[activeFilter.value];
    if (!filter) return algorithms;

    if (filter.items === 'all') return algorithms;

    return algorithms.filter((algo) => filter.items.includes(algo.id));
  });

  const setFilter = (filterName) => {
    activeFilter.value = filterName;
  };

  const isFilterActive = (filterName) => {
    return computed(() => activeFilter.value === filterName);
  };

  return {
    activeFilter,
    visibleAlgorithms,
    setFilter,
    isFilterActive,
  };
}
